/** Display model from path slug (v90 → V90, xc-60 → XC 60). */
export const formatModelDisplayName = (model?: string): string => {
    if (!model) {
        return "";
    }
    return model.replace(/-/g, " ").toUpperCase();
};
